



























import { defineComponent, PropType, ref, watch } from '@vue/composition-api';
import { Person } from '@/graphql';
import EditableFields from '@/components/Fields/EditableFields.vue';
import EditableCard from '@/components/Cards/EditableCard.vue';

export type OnSubmitCallback = (data: Person) => Promise<void>;

export default defineComponent({
  components: {
    EditableCard,
    EditableFields,
  },
  props: {
    person: {
      type: Object as PropType<Person | null>,
      required: false,
      default: null,
    },
    onSubmit: {
      type: Function as PropType<OnSubmitCallback>,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const model = ref<Person | null>(props.person ? { ...props.person } : null);

    watch(
      () => props.person,
      (newValue) => {
        model.value = newValue ? { ...newValue } : null;
      },
    );

    return {
      model,
      submit: async (after: Function[] = []) => {
        if (model.value) {
          await props.onSubmit(model.value);
        }
        after.forEach((func) => func());
      },
    };
  },
});
